/* eslint-disable default-case */
import React, { useState, useEffect, useContext } from "react";
import CreatableSelect from "react-select/creatable";
import NodeContext from "../../context/NodeContext";

const components = {
  DropdownIndicator: null,
};

const createOption = (label) => ({
  label,
  value: label,
});

// EDS-styled custom styles for react-select
// Note: CSS variables use oklch() values, so we use var() directly instead of wrapping in hsl()
const edsSelectStyles = {
  control: (base, state) => ({
    ...base,
    textAlign: "left",
    minHeight: "36px",
    borderRadius: "6px",
    borderColor: state.isFocused ? "#007372" : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 115, 114, 0.2)" : "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    backgroundColor: "#ffffff",
    "&:hover": {
      borderColor: "#007372",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "7px",
  }),
  input: (base) => ({
    ...base,
    margin: "0",
    padding: "0",
    color: "#1f2937",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6b7280",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e5f5f5",
    borderRadius: "4px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#007372",
    fontSize: "14px",
    padding: "2px 6px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#6b7280",
    "&:hover": {
      backgroundColor: "#ef4444",
      color: "#ffffff",
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#ffffff",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    zIndex: 50,
    position: "absolute",
  }),
  menuList: (base) => ({
    ...base,
    padding: "4px 0",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#e5f5f5" : "transparent",
    color: state.isFocused ? "#007372" : "#1f2937",
    cursor: "pointer",
    padding: "8px 12px",
    "&:active": {
      backgroundColor: "#e5f5f5",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#6b7280",
    "&:hover": {
      color: "#1f2937",
    },
  }),
};

export default function CreateableSelect(props) {
  const { type, placeholder } = props;
  const [inputValue, setInputValue] = useState("");
  const { variableList, selectedNodeInfo, updateNode } =
    useContext(NodeContext);

  const [value, setValue] = useState(
    type === "numbers"
      ? selectedNodeInfo?.data?.toNumbers
      : selectedNodeInfo?.data?.toEmails ?? []
  );

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setValue((prev) => prev ? [...prev, createOption(inputValue)] : [createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
    }
  };

  useEffect(() => {
    type === "emails"
      ? updateNode(selectedNodeInfo.id, {
          ...selectedNodeInfo?.data,
          toEmails: value,
        })
      : updateNode(selectedNodeInfo.id, {
          ...selectedNodeInfo?.data,
          toNumbers: value,
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <CreatableSelect
      components={components}
      inputValue={inputValue}
      isClearable
      isMulti
      options={variableList.map((item) => ({
        value: `{${item.value}`,
        label: item.label,
      }))}
      onChange={(newValue) => {
        setValue(newValue);
      }}
      onInputChange={(newValue) => setInputValue(newValue)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      value={value}
      styles={edsSelectStyles}
    />
  );
}
